<template>
    <div class="footer-intro-wrapper">
        <h4 class="footer-widget__title">{{data.title}}</h4>
        <div class="footer-desc">
            {{ data.content }}
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data' ]
    };
</script>